import "./styles/main.scss";
import { Components } from "./components";

export default class Main {
  constructor(options) {
    this.component = [];
    this.init();
  }

  init() {
    const components = document.querySelectorAll("[data-component]");

    components.forEach((component) => {
      const type = component.dataset.component;
      switch (type) {
        case "Search":
          new Components["Search"](component);
          break;
        case "OverlaySubscribe":
          new Components["OverlaySubscribe"](component);
          break;
        case "OverlayDeleteParticipant":
          new Components["OverlayDeleteParticipant"](component);
          break;
        case "Quiz":
          new Components["Quiz"](component);
          break;
      }
    });
  }
}

new Main();
